function VariableModalController(stateService) {
  const ctrl = this;

  ctrl.$onInit = () => {
    ctrl.workspaceId = ctrl.resolve.workspaceId;
    ctrl.view = ctrl.resolve.view;
    stateService.getVariables(ctrl.workspaceId).then(data => ctrl.variables = data);
    ctrl.types = [
      { id: 1, name: 'Existing' },
      { id: 2, name: 'New' },
    ];
  };

  ctrl.submit = () => {
    ctrl.close({ $value: ctrl.variable });
  };

  ctrl.cancel = () => {
    ctrl.dismiss({ $value: 'cancel' });
  };
}

angular
  .module('pis-tool.module')
  .controller('VariableModalController', VariableModalController);
